__turbopack_context__.v({
  "main": "StartIndex-module-scss-module__lnUQUW__main",
});
